import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import { ReducerContainerState } from "./types";
import {
  isPersonalizationFetching,
  receiveServerPersonalization,
  restoreDefaultColors,
  setColors,
  updatePersonalization,
  updatePersonalizationHasError,
  updatePersonalizationInfo,
  updatePersonalizationState,
  updatePersonalizationTitle,
} from "./actionCreators";
import serverPersonalizationDataReducer from "./subreducers/serverPersonalizationDataReducer";

const initialState: ReducerContainerState = {
  serverPersonalization: null,
  isFetching: false,
  stateChanged: false,
  hasError: false,
};

const personalizationReducer = reducer(
  initialState,
  on(receiveServerPersonalization, (state, action) => {
    state.serverPersonalization = serverPersonalizationDataReducer(
      state.serverPersonalization,
      action
    );
    state.stateChanged = false;
  }),
  on(
    ...union(
      updatePersonalization,
      updatePersonalizationTitle,
      updatePersonalizationInfo,
      setColors,
      restoreDefaultColors
    ),
    (state, action) => {
      if (action.error) return;
      state.serverPersonalization = serverPersonalizationDataReducer(
        state.serverPersonalization,
        action
      );
      state.stateChanged = true;
    }
  ),
  on(updatePersonalizationHasError, (state, { payload: { hasError } }) => {
    state.hasError = hasError;
  }),
  on(isPersonalizationFetching, (state, { payload: { flag } }) => {
    state.isFetching = flag;
  }),
  on(updatePersonalizationState, (state, action) => {
    state.stateChanged = action.payload.state;
  })
);

export default personalizationReducer;
